import { JobLevel } from 'components/employee-analytics/analytic-item/JobLevel'
import { useState, useRef, useEffect } from 'react'
import { API_EMPLOYEE_ANALYTICS } from 'services/apiEmployeeAnalytics'
import { useFetch } from 'services/useFetch'

const INITIAL_FILTER = {
    employee_type: null,
    company_ids: [],
    department_ids: [],
    division_ids: [],
    sub_division_ids: [],
}

const JobLevelContainer = () => {
    const { fetching: getJobLevel, isLoading } = useFetch(API_EMPLOYEE_ANALYTICS.JOB_LEVEL)
    const [jobLevelData, setJobLevelData] = useState({})
    const [active, setActive] = useState(null)
    const [isBottom, setIsBottom] = useState(false)
    const [filter, setFilter] = useState(INITIAL_FILTER)
    const scrollRef = useRef(null)

    const styleBar = (key) => {
        switch (key) {
            case 'Chief Executive Level':
                return { color: 'bg-sky-500', light: 'hover:bg-sky-400' }
            case 'Chief Level':
                return { color: 'bg-orange-400', light: 'hover:bg-orange-300' }
            case 'Director':
                return { color: 'bg-indigo-500', light: 'hover:bg-indigo-400' }
            case 'Group Head':
                return { color: 'bg-rose-500', light: 'hover:bg-rose-400' }
            case 'Head Level':
                return { color: 'bg-lime-500', light: 'hover:bg-lime-400' }
            case 'Senior Manager':
                return { color: 'bg-violet-500', light: 'hover:bg-violet-400' }
            case 'Manager':
                return { color: 'bg-red-500', light: 'hover:bg-red-400' }
            case 'Junior Manager':
                return { color: 'bg-yellow-400', light: 'hover:bg-yellow-300' }
            case 'Senior Executive':
                return { color: 'bg-cyan-500', light: 'hover:bg-cyan-400' }
            case 'Executive':
                return { color: 'bg-teal-500', light: 'hover:bg-teal-400' }
            case 'Junior Executive':
                return { color: 'bg-pink-500', light: 'hover:bg-pink-400' }
            case 'Senior Staff':
                return { color: 'bg-green-500', light: 'hover:bg-green-400' }
            case 'Staff':
                return { color: 'bg-blue-500', light: 'hover:bg-blue-400' }
            case 'Service':
                return { color: 'bg-purple-500', light: 'hover:bg-purple-400' }
            default:
                return { color: 'bg-slate-500', light: 'hover:bg-slate-400' }
        }
    }

    useEffect(() => {
        ;(async () => {
            const jobLevel = await getJobLevel(filter)
            const newData = {
                ...jobLevel?.data,
                detail: jobLevel?.data?.detail?.map((item) => {
                    const { job_level_name, ...restItem } = { ...item }
                    return { ...restItem, ...styleBar(item?.job_level_name), label: job_level_name }
                }),
            }

            setJobLevelData(newData)
        })()
    }, [filter])

    const handleScroll = () => {
        const el = scrollRef.current
        if (!el) return

        const isAtBottom = el.scrollHeight - el.scrollTop <= el.clientHeight + 1

        setIsBottom(isAtBottom)
    }

    const onSubmitFilter = (newFilter) => {
        if (JSON.stringify(filter) !== JSON.stringify(newFilter)) {
            setFilter(newFilter)
        }
    }

    const props = {
        active,
        setActive,
        data: jobLevelData,
        isLoading,
        isBottom,
        scrollRef,
        handleScroll,
        filter,
        onSubmitFilter,
    }

    return <JobLevel {...props} />
}

export default JobLevelContainer
